var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8936 6.53194V4.79787C14.8936 2.92661 13.3712 1.40426 11.5 1.40426C9.62872 1.40426 8.10636 2.92661 8.10636 4.79787V6.53194C8.09869 6.53517 8.09096 6.53812 8.08329 6.54135C7.59896 6.74618 7.13794 6.99244 6.70211 7.27737V4.79787C6.70211 2.1523 8.85441 0 11.5 0C14.1455 0 16.2979 2.1523 16.2979 4.79787V7.27732C15.862 6.99244 15.401 6.74618 14.9167 6.5413C14.909 6.53812 14.9013 6.53517 14.8936 6.53194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 7.25537C15.5714 7.25537 18.8721 10.5561 18.8721 14.6277C18.8721 18.6993 15.5714 22.0001 11.4997 22.0001C7.42809 22.0001 4.12739 18.6993 4.12739 14.6277C4.12739 10.5561 7.42809 7.25537 11.4997 7.25537ZM10.7976 15.0049V17.5118H12.2019V15.0049C12.7553 14.7419 13.138 14.178 13.138 13.5245C13.138 12.6197 12.4045 11.8862 11.4997 11.8862C10.5949 11.8862 9.86143 12.6197 9.86143 13.5245C9.86143 14.178 10.2441 14.742 10.7976 15.0049Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.3a973577884f41b1581dae67521e32be.svg";
export { ForwardRef as ReactComponent };